import Toncoin from './Toncoin';

export default Toncoin;
